var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 75 74",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: {
          x: "17.5",
          y: "16.5",
          width: "57",
          height: "57",
          fill: "white",
          stroke: "currentColor"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "2",
          y: "2",
          width: "71",
          height: "12",
          fill: "white",
          stroke: "currentColor",
          "stroke-width": "4"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "2",
          y: "18",
          width: "13",
          height: "54",
          fill: "white",
          stroke: "currentColor",
          "stroke-width": "4"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "4", y: "4", width: "9", height: "66", fill: "white" }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M40 30.5L31.5 39C30.6716 39.8284 30.6716 41.1716 31.5 42C32.3284 42.8284 33.6716 42.8284 34.5 42L43 33.5C43.8284 32.6716 43.8284 31.3284 43 30.5C42.1716 29.6716 40.8284 29.6716 40 30.5Z",
          fill: "currentColor",
          stroke: "currentColor"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M53 35.5L44.5 44C43.6716 44.8284 43.6716 46.1716 44.5 47C45.3284 47.8284 46.6716 47.8284 47.5 47L56 38.5C56.8284 37.6716 56.8284 36.3284 56 35.5C55.1716 34.6716 53.8284 34.6716 53 35.5Z",
          fill: "currentColor",
          stroke: "currentColor"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M45 43.5L36.5 52C35.6716 52.8284 35.6716 54.1716 36.5 55C37.3284 55.8284 38.6716 55.8284 39.5 55L48 46.5C48.8284 45.6716 48.8284 44.3284 48 43.5C47.1716 42.6716 45.8284 42.6716 45 43.5Z",
          fill: "currentColor",
          stroke: "currentColor"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M58 48.5L49.5 57C48.6716 57.8284 48.6716 59.1716 49.5 60C50.3284 60.8284 51.6716 60.8284 52.5 60L61 51.5C61.8284 50.6716 61.8284 49.3284 61 48.5C60.1716 47.6716 58.8284 47.6716 58 48.5Z",
          fill: "currentColor",
          stroke: "currentColor"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: { d: "M4 4L18 17", stroke: "currentColor", "stroke-width": "4" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }